import React, { useState, useEffect, useMemo } from "react"
import _isEmpty from "lodash/isEmpty"
import InspirationDetailView from "@/components/InspirationDetail/v1/InspirationDetail.view"
import { getProductsBySku } from "@/components/sharedCart/shareCartHelper"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getInspirationDetails } from "@/store/features/inspirationSlice"
import { useTranslation } from "next-i18next"
import { useSelector, useDispatch } from "react-redux"
import { useRouter } from "next/router"

const InspirationDetail = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const router = useRouter()

  const [productData, setProductData] = useState([])
  const [selectedInspiration, setSelectedInspiration] = useState({})
  const [authComponentProps, setAuthComponentProps] = useState(props.authorData)
  const [curFilterQueries, setCurFilterQueries] = useState(null)
  const [start, setStart] = useState(0)
  const [rows, setRows] = useState(10) // Example default value
  const [selectedSort, setSelectedSort] = useState(null)
  const { inspirations, favorites, cart } = useSelector(state => state)
  const { selectedInspiration: selectedInspirationState } =
    inspirations?.inspirations || {}
  const detailsPageSelectedInspiration =
    selectedInspirationState?.data?.[0] || {}
  const favoritesState = favorites?.favorites?.textLineItems ?? []
  const cartState = cart?.cart

  const getComponentProp = () => {
    const el =
      document.querySelector("[data-component='InspirationDetail']") ?? ""
    if (el) {
      const staticText = JSON?.parse(el?.dataset?.staticText)
      setAuthComponentProps(staticText)
    }
  }
  useEffect(() => {
    const fetchProductData = async () => {
      if (
        props.selectedInspiration &&
        props.selectedInspiration.ProductMappingSKUID_s
      ) {
        const productData = await getProductsBySku(
          props.selectedInspiration.ProductMappingSKUID_s.split(",").map(x =>
            x.trim()
          )
        )
        setSelectedInspiration(props.selectedInspiration)
        setProductData(productData)
      } else {
        getInspirationItem()
      }
    }

    if (_isEmpty(props.authorData)) {
      getComponentProp()
    }

    fetchProductData()
  }, [props.selectedInspiration, props.authorData])

  useEffect(() => {
    const fetchProductData = async () => {
      if (
        selectedInspirationState &&
        selectedInspirationState.data &&
        selectedInspirationState.data.length > 0 &&
        selectedInspirationState.data[0].ProductMappingSKUID_s &&
        !selectedInspiration.id
      ) {
        const productData = await getProductsBySku(
          selectedInspirationState.data[0].ProductMappingSKUID_s.split(",").map(
            x => x.trim()
          )
        )
        setSelectedInspiration(selectedInspirationState?.data[0])
        setProductData(productData)
      }
    }

    fetchProductData()
  }, [selectedInspirationState, detailsPageSelectedInspiration.id])

  const getInspirationItem = (queries, update) => {
    let newStart = 0
    //save queries to handle sorting
    if (queries) {
      setCurFilterQueries(queries)
    } else {
      queries = curFilterQueries
      newStart = start
    }

    // let pathName = window.location.pathname
    // const splittedPath = pathName?.split("/")
    // const last = splittedPath[splittedPath.length - 1]
    // const pathId = last?.replace(".html", "")
    const {
      query: { q },
    } = router
    const pathId = q
    let fq = []
    fq.push(`id:("${pathId}")`)
    let query = {
      fq,
      rows,
      start: newStart,
    }
    if (selectedSort) query.sort = selectedSort
    dispatch(getInspirationDetails({ query, update, isSingle: true }))
  }
  const i18n = {
    photoCredits: "Photo Credit : ",
    orderASample: "Order a Sample",
    addToCart: "Add to Cart",
  }
  const staticTexts = useMemo(
    () => ({
      print: t("kf.plp.label.print"),
      share: t("kf.plp.label.share"),
      favTxt: t("kf.pdp.label.favTxt"),
      favSuccessMsg: t("kf.favorites.success"),
      favErrorMsg: t("kf.favorites.error"),
      removeItem: t("kf.favorites.removeItem"),
      removeItemError: t("kf.favorites.removeItemError"),
      itemsAdded: t("kf.pdp.label.itemAdded"),
      customOrderContactUs: t("annsacks.customOrderSample.label.contactUsBtn"),
    }),
    []
  )

  // if (
  //   typeof props.isModalShow === "undefined" &&
  //   !window.location.pathname.includes("inspiration-detail")
  // ) {
  //   return null
  // }

  if (
    (props?.isDetailsPage && !detailsPageSelectedInspiration.id) ||
    (!props?.isDetailsPage && !selectedInspiration.id)
  ) {
    return <div className="inspiration-detail-before-load">Loading ...</div>
  } else {
    return (
      <InspirationDetailView
        selectedInspiration={
          props?.isDetailsPage
            ? detailsPageSelectedInspiration
            : selectedInspiration
        }
        productData={productData}
        favorites={favoritesState}
        staticTexts={staticTexts}
        addToCart={() => {}}
        i18n={i18n}
        componentProps={authComponentProps}
        sku={
          props?.isDetailsPage
            ? detailsPageSelectedInspiration.ProductMappingSKUID_s.split(
                ","
              ).map(x => x.trim())
            : selectedInspiration.ProductMappingSKUID_s.split(",").map(x =>
                x.trim()
              )
        }
        isOverlay={props.isOverlay}
        getVarientProductInfo={props?.getVarientProductInfo}
        cart={cartState}
      />
    )
  }
}

export default InspirationDetail
